module.exports = __webpack_public_path__ + "static/media/teygja_armbeygja_a.745169d0.png";